

const getDatee = (calculatedDate) => {

    const date = new Date()
    const currentDate = calculatedDate || date
    
    const day = currentDate.getDate();
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();

    const fixedDay = day < 10 ? `0${day}` : day
    const fixedMonth = (month + 1) < 10 ?  `0${month + 1}`: month + 1

    return `${year}-${fixedMonth}-${fixedDay}`
}
    
export  {getDatee}